module.exports = __webpack_public_path__ + "static/media/1.78287499.jpg";